module.exports.timedPromise = (time) ->
  new Em.RSVP.Promise (resolve, reject) ->
    Em.run.later(resolve, time)